<script type="text/javascript" async>
	import HeaderUser from "./header/user.svelte";
	import HeaderMenu from "./header/menu.svelte";
	import Icon from "./icon.svelte";
	export let api;

	let mobile_menuOpened = false;

	let user = undefined; var state;
	api.getUser(u=>{
		user = u;
		user.updateUser_subscribe(u=>setUState(u));
		setUState(user);
	});
	function setUState(user){
		if (!user) state = -1;
		else if (!user.logged) state = -1;
		else state = user.access;
	}



</script>

<div class="app_header">
	<a href="https://tradestore.su" class="logo"> 
		<img src="/assets/img/logo.png" class="logo">
	</a>
	<hr>



	<button class="app_button-transparent menu-collapse"
			on:click={e=>mobile_menuOpened=!mobile_menuOpened}>
		<Icon menu/></button>
	<div class="menu" class:show={mobile_menuOpened}>
		<div class="h">
			<button class="app_button-transparent menu-close"
					on:click={e=>mobile_menuOpened=false}>
				<Icon close/>
			</button>
		</div>
		<div class="user">
			{#if user}
				<HeaderUser bind:mobile_menuOpened user={user}/>
			{/if}
		</div>
		<hr>
		<div class="hmenu">
			<HeaderMenu bind:state/>
		</div>
	</div>
</div>
<div class="app_header-clearfix"></div>

<style type="text/css">
	.hmenu{
		max-height: 58vh;
		overflow-y: auto;
		margin-top: -14px;
	}
	
	@media(min-width: 1015px){
		:global(body.svelte_widget > #head-widget > .app_header){
			width: 280px;
		}
		.app_header{
			min-height: 100vh;
			height: 100vh;
			width: 250px;

			padding: 28px 20px;

		}
		.app_header-clearfix{
			margin-right: 300px;
		}
		.menu-collapse{
			display: none;
		}
		.menu{
			max-height: 100%;
		}
		.app_header > .menu > .h{display: none;}
	}
	@media(max-width: 1015px){
		.user, .menu{

			z-index: 1000000;
		}
		.app_header{
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 15px 10px;
			width: 100vw;
			position: fixed;
			left: 0;
			top: 0;
			box-sizing: border-box; z-index: 1000001;
		}
		div.logo{display: block !important;}
		.app_header > .menu{display: none;}
		.app_header > .menu > .h{
			display: flex;
			justify-content: flex-end;
			margin-bottom: -24px;
		}
		.menu-close{padding: 0!important;    z-index: 1000001;
			position: relative;}
		.app_header > .menu.show{
			display: block;
			position: absolute;
			right: 15px;
			top: 100px;


			padding: 7px 14px;
			background: #0D1219;
			border-radius: 15px;
			border: 1px solid #25253A;
		}
		.app_header-clearfix{
			margin-bottom: 95px;
		}
		.app_header > hr{display: none;}
	}
	.app_header{
		background: #0D1219;
		border: 1px solid #25253A;
		position: fixed !important;

	}

	a.logo{
		display: flex;
		width: 100%;
		justify-content: center;
		text-decoration: none;
		color:white;
	}
</style>